module.exports = __webpack_public_path__ + "img/pr-1.7d951ccb.png";